import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useEnrollmentFlowEnabled } from "src/ui/containers/dashboard/enrollment/utils/useEnrollmentFlowEnabled";
import { PrimaryButton } from "src/ui/shared/CustomButton";
import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SectionPanel } from "@shared/SectionPanel/SectionPanel";

const useStyles = makeStyles()((muiTheme: Theme) => ({
    card: {
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: muiTheme.spacing(3),
        minHeight: 280,
        boxSizing: "border-box",
    },
    message: {
        color: muiTheme.palette.emteria.text.secondary,
        textAlign: "center",
        maxWidth: 480,
    },
}));

export const EnrollFirstDeviceSection = () => {
    const { classes } = useStyles();
    const { t } = useTranslation(["pages"]);
    const navigate = useNavigate();
    const isEnrollmentFlowEnabled = useEnrollmentFlowEnabled();

    return (
        <SectionPanel>
            <Box className={classes.card}>
                <Typography className={classes.message}>{t("pages:overviewPage.enrollFirstDevice.message")}</Typography>
                {isEnrollmentFlowEnabled ? (
                    <PrimaryButton onClick={() => navigate("/dashboard/enrollment")} name="enroll-first-device">
                        {t("pages:overviewPage.enrollFirstDevice.button")}
                    </PrimaryButton>
                ) : null}
            </Box>
        </SectionPanel>
    );
};
